import { motion } from "framer-motion";
import { images } from "@/lib/weddingData";
import VenueCarousel from "./VenueCarousel";

const venueSlides = [
  {
    src: "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/eth72vja_WhatsApp%20Image%202026-07-27%20at%2016.06.07.jpeg",
    alt: "Cortijo de Enmedio — jardín y montaje al atardecer",
  },
  {
    src: images.venueOutdoor,
    alt: "Cortijo de Enmedio — vista exterior",
  },
];

const Location = () => {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="border-t border-[#c9c3b3] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]"><span style={{ color: "#891613" }}>(03)</span> — El lugar</p>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-8"
          >
            <h2 className="display-xl">
              Cortijo
              <br />
              de Enmedio.
            </h2>
          </motion.div>
          <div className="col-span-12 md:col-span-4 md:pt-8">
            <p className="body-lead max-w-md">
              Un cortijo andaluz entre olivos y jardines, en la Vega de Granada.
              La ceremonia y la celebración serán en el mismo lugar — sin
              prisas y sin traslados.
            </p>
          </div>
        </div>

        {/* Venue carousel — same aspect ratio and styling as before, with 2–3 photos */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="mt-16"
        >
          <VenueCarousel images={venueSlides} />
        </motion.div>

        {/* Single clean note — no redundancy */}
        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-3">
            <p className="corner-label text-[#8a8580]">Reservad el día</p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <p className="body-lead max-w-2xl">
              Reservad la tarde y la noche del{" "}
              <span className="font-semibold" style={{ color: "#891613" }}>4 de junio</span>.
              Compartiremos el horario definitivo más adelante.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
